import React from 'react';

import LogoSVG from '../../assets/icons/logo.svg';
import { Divider, Flex, Typography } from '../../designComponents';
import General from './Generral';
import Resources from './Resources';
import Services from './Services';
import Social from './Social';
import { Container, FooterWrapperStyled, Logo, Text } from './style';
import Support from './Support';

type Props = {};

const Footer = (_props: Props) => {
  return (
    <FooterWrapperStyled>
      <div className="content">
        <Container>
          <Logo>
            <img src={LogoSVG} alt="logo" />
            <Text>
              <Typography className="text" size={16}>
                Evacuation plan
              </Typography>
              <Typography size={14} className="text">
                Saas Application
              </Typography>
            </Text>
          </Logo>
          <General />
          <Resources />
          <Services />
          <Support />
          <Social />
        </Container>
        <Divider bgColor="gray" />
        <Flex wrap="wrap" alignItems="center" justifyContent="center">
          <Typography className="footer-text">
            Copyright © 2024, All Rights Reserved
          </Typography>
          <Typography className="footer-text">Terms and Services </Typography>
          <Typography className="footer-text">Privacy Policy </Typography>
        </Flex>
      </div>
    </FooterWrapperStyled>
  );
};

export default Footer;
